"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateLineCommission = calculateLineCommission;
/** Round to cents, half-up, avoiding binary float drift. */
const toCents = (n) => Math.round((n + Number.EPSILON) * 100) / 100;
/**
 * Commission earned on a single sold line. Pure & side-effect free so it can be
 * called identically from the sale path and from tests.
 * - flat_per_unit:  value × quantity
 * - percent_of_sale: value% × lineTotalPaid, capped at maxAmount if set
 */
function calculateLineCommission(rate, ctx) {
    if (ctx.quantity <= 0 || ctx.lineTotalPaid <= 0)
        return 0;
    if (rate.type === 'flat_per_unit') {
        return toCents(rate.value * ctx.quantity);
    }
    const raw = (rate.value / 100) * ctx.lineTotalPaid;
    const capped = rate.maxAmount != null ? Math.min(raw, rate.maxAmount) : raw;
    return toCents(capped);
}
//# sourceMappingURL=commission.js.map